import { Reveal, Overline } from "../Reveal";
import { ASSETS } from "../assets";

export default function Slide10Contact() {
  return (
    <section className="slide bg-[var(--ais-cream)]" data-testid="slide-10">
      <div className="grid grid-cols-1 md:grid-cols-12 min-h-screen">
        <div className="md:col-span-5 relative bg-[var(--ais-espresso)] min-h-[40vh] md:min-h-screen overflow-hidden">
          <img
            src={ASSETS.logo}
            alt="AIS — Artistic Italian Shoes"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>

        <div className="md:col-span-7 flex items-center px-6 md:px-16 py-20">
          <div className="max-w-xl">
            <Reveal>
              <Overline>10 — Contact</Overline>
            </Reveal>
            <Reveal delay={1}>
              <div className="hairline w-16 my-8" />
            </Reveal>
            <Reveal delay={2}>
              <h2 className="font-serif text-3xl md:text-4xl lg:text-[2.75rem] text-[var(--ais-espresso)] leading-[1.1] tracking-[-0.01em] font-light">
                Let us build the next chapter
                <br />
                of <em className="italic">Italian</em> luxury
                <br />
                in the <em className="italic">Gulf</em>, together.
              </h2>
            </Reveal>

            <div className="mt-12 space-y-6">
              {[
                { k: "Email", v: "info@artisticitalianshoes.com" },
                { k: "Phone", v: "+39 327 589 3397" },
              ].map((c, i) => (
                <Reveal key={c.k} delay={3 + i}>
                  <div className="border-b border-[var(--ais-gold-soft)] pb-5">
                    <div className="font-sans text-[0.65rem] tracking-luxe uppercase text-[var(--ais-leather)]">
                      {c.k}
                    </div>
                    <div className="mt-2 font-serif italic text-xl md:text-2xl text-[var(--ais-espresso)] font-light">
                      {c.v}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={7}>
              <div className="mt-12 font-sans text-[0.6rem] tracking-luxe uppercase text-[var(--ais-text)] opacity-70">
                © 2026 Artistic Italian Shoes · Made in Italy
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
